/**
 * @generated SignedSource<<74f153f279691d8f856667da51a03cbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoleActivateMutation$variables = {
  id: number;
};
export type RoleActivateMutation$data = {
  readonly activateRole: {
    readonly role: {
      readonly active: boolean;
      readonly id: number;
      readonly name: string;
    } | null | undefined;
  };
};
export type RoleActivateMutation = {
  response: RoleActivateMutation$data;
  variables: RoleActivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoleChangedResult",
    "kind": "LinkedField",
    "name": "activateRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "roles",
        "kind": "LinkedField",
        "name": "role",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoleActivateMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoleActivateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "337b513fb38d6c161a1cc38d5704808f",
    "id": null,
    "metadata": {},
    "name": "RoleActivateMutation",
    "operationKind": "mutation",
    "text": "mutation RoleActivateMutation(\n  $id: Int!\n) {\n  activateRole(id: $id) {\n    role {\n      id\n      name\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "899634628303688e6ae437c9ef90fee5";

export default node;
